import { createStore, applyMiddleware } from 'redux';
import socialManagerReducer from '../reducers/socialManagerReducer';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';

const configureStore = (railsProps) => (
  createStore(socialManagerReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
